import React from "react";

const Proficient = () => {
  const proficientData = [
    {
      id: 1,
      title: "Hospitality",
      desc: "Having developed a top-of-the-line hotel management software, we possess a crystal-clear understanding of the hospitality sector's unique needs. Our expertise is reflected in our ability to create intuitive systems that not only streamline hotel operations but also significantly enhance guest satisfaction.",
      color: "#F2F7FF",
    },
    {
      id: 2,
      title: "Financial reporting",
      desc: "Our software solutions in the financial sector stand out for their robust reporting and precise accounting capabilities. Designed to simplify complex financial tasks, they ensure unparalleled transparency and compliance at every turn.",
      color: "#FFF5F5",
    },
    {
      id: 3,
      title: "Event management",
      desc: "From ticketing systems to real-time event coordination tools, we deliver solutions that streamline processes and enhance event experiences for both organizers and attendees.",
      color: "#F2F7FF",
    },
    {
      id: 4,
      title: "Coaching",
      desc: "We excel at crafting exceptional, analytical systems tailored to benefit all parties involved: customers, coaches, and company operations, ensuring seamless interaction and optimal results.",
      color: "#FFF5F5",
    },
  ];
  return (
    <div className="mainContainer">
      <div>
        {
          <div className="proficient-card-content">
            <h1 style={{ fontSize: 40 }}>
              Proficient in a <br /> variety of <br /> sectors
            </h1>
            {proficientData.slice(0, 2).map((item) => {
              return (
                <div
                  key={item.id}
                  className="proficient-card"
                  style={{ backgroundColor: item.color }}
                >
                  <h3 className="proficient-title">{item.title}</h3>
                  <p className="proficient-description">{item.desc}</p>
                </div>
              );
            })}
          </div>
        }
      </div>
      <div>
        {
          <div className="proficient-card-content">
            {proficientData.slice(2).map((item) => {
              return (
                <div
                  key={item.id}
                  className="proficient-card"
                  style={{ backgroundColor: item.color }}
                >
                  <h3 className="proficient-title">{item.title}</h3>
                  <p className="proficient-description">{item.desc}</p>
                </div>
              );
            })}
            <div className="proficient-card hire-me">
              <div className="proficient-title hire-me-title">
                <span>Hire Me</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default Proficient;
